import { StatusBar, Style } from '@capacitor/status-bar';
import { isNativeApp } from './nativeApp';

// Primary accent hex per persona — kept in sync with personaTheme.ts.
// These are the solid `bg` accent shades each persona uses (e.g. job-seeker
// bg-blue-500 = #3b82f6, which also matches the prior hardcoded status-bar
// colour in capacitor.config.ts). Update both files together if the palette
// ever changes.
const PERSONA_STATUS_BAR_COLOR: Record<string, string> = {
  'job-seeker':          '#3b82f6', // blue-500
  'individual-employer': '#10b981', // emerald-500
  'business-employer':   '#fbbf24', // amber-400
  'provider':            '#8b5cf6', // violet-500
  'agency':              '#ec4899', // pink-500
  'admin':               '#475569', // slate-600
};

// Call once on app mount — ensures the status bar never overlays the WebView.
// Must run before persona is known so the header is visible from first paint.
export const initStatusBar = async () => {
  if (!isNativeApp()) return;
  try {
    await StatusBar.setOverlaysWebView({ overlay: false });
    await StatusBar.setBackgroundColor({ color: '#3b82f6' });
    await StatusBar.setStyle({ style: Style.Light });
  } catch { /* non-fatal */ }
};

export const applyPersonaStatusBar = async (persona: string | null) => {
  if (!isNativeApp()) return;
  const color = persona ? (PERSONA_STATUS_BAR_COLOR[persona] ?? '#3b82f6') : '#3b82f6';
  try {
    await StatusBar.setOverlaysWebView({ overlay: false });
    await StatusBar.setBackgroundColor({ color });
    await StatusBar.setStyle({ style: Style.Light });
  } catch { /* non-fatal */ }
};
